import React, { useEffect } from 'react';
import OrganizationFilter from './OrganizationFilter';
import GridConditionHistory from './GridConditionHistory';
import { RootState, useDispatch, useSelector } from '../../../redux/store';
import { getConditionHistoryList } from '../../../redux/slices/approval';
import { APPROVAL_VIEW_MODES } from '../../../constants';

const ConditionHistoryGrid = (): React.ReactElement => {
  const dispatch = useDispatch();
  const { isLoading, selectedOrganizationId, conditionHistory, confirmCondition, selectedViewMode } = useSelector((state: RootState) => state.approval);
  const { adminPowerUsers } = useSelector((state: RootState) => state.user);
  const { steelMaker, businessType, steelCategory } = useSelector((state: RootState) => state.options);

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // /**
  //  * ステータスが変わったらconditionを再取得する
  //  */
  useEffect(() => {
    if (confirmCondition) {
      dispatch(getConditionHistoryList(selectedOrganizationId));
    } else {
      // do nothing
    }
  }, [confirmCondition?.conditionStatus]);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <>
      {selectedViewMode === APPROVAL_VIEW_MODES.HISTORY && (
        <>
          <OrganizationFilter selectedOrganizationId={selectedOrganizationId} />
          <GridConditionHistory
            isLoading={isLoading}
            selectedOrganizationId={selectedOrganizationId}
            conditionHistory={conditionHistory}
            confirmCondition={confirmCondition}
            steelMaker={steelMaker}
            businessType={businessType}
            steelCategory={steelCategory}
            adminPowerUsers={adminPowerUsers}
          />
        </>
      )}
    </>
  );
};

export default ConditionHistoryGrid;
